import { render, staticRenderFns } from "./proposal-detail.vue?vue&type=template&id=0cf9bffe"
import script from "./proposal-detail.vue?vue&type=script&lang=js"
export * from "./proposal-detail.vue?vue&type=script&lang=js"
import style0 from "./proposal-detail.vue?vue&type=style&index=0&id=0cf9bffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports